import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _42693f3c = () => interopDefault(import('../../pages/billings/index.vue' /* webpackChunkName: "pages/billings/index" */))
const _0e84d6f5 = () => interopDefault(import('../../pages/contact-us/index.vue' /* webpackChunkName: "pages/contact-us/index" */))
const _f125a9f2 = () => interopDefault(import('../../pages/forget-password/index.vue' /* webpackChunkName: "pages/forget-password/index" */))
const _1de12bb5 = () => interopDefault(import('../../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _776e8812 = () => interopDefault(import('../../pages/payments/index.vue' /* webpackChunkName: "pages/payments/index" */))
const _28e15826 = () => interopDefault(import('../../pages/usage/index.vue' /* webpackChunkName: "pages/usage/index" */))
const _5664a9f4 = () => interopDefault(import('../../pages/payments/checkout/index.vue' /* webpackChunkName: "pages/payments/checkout/index" */))
const _1b7ea424 = () => interopDefault(import('../../pages/payments/thank-you/index.vue' /* webpackChunkName: "pages/payments/thank-you/index" */))
const _f7b3178e = () => interopDefault(import('../../pages/reset-password/_token.vue' /* webpackChunkName: "pages/reset-password/_token" */))
const _7429e40c = () => interopDefault(import('../../pages/set-password/_token.vue' /* webpackChunkName: "pages/set-password/_token" */))
const _01554f9b = () => interopDefault(import('../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'active',
  scrollBehavior,

  routes: [{
    path: "/billings",
    component: _42693f3c,
    name: "billings"
  }, {
    path: "/contact-us",
    component: _0e84d6f5,
    name: "contact-us"
  }, {
    path: "/forget-password",
    component: _f125a9f2,
    name: "forget-password"
  }, {
    path: "/login",
    component: _1de12bb5,
    name: "login"
  }, {
    path: "/payments",
    component: _776e8812,
    name: "payments"
  }, {
    path: "/usage",
    component: _28e15826,
    name: "usage"
  }, {
    path: "/payments/checkout",
    component: _5664a9f4,
    name: "payments-checkout"
  }, {
    path: "/payments/thank-you",
    component: _1b7ea424,
    name: "payments-thank-you"
  }, {
    path: "/reset-password/:token?",
    component: _f7b3178e,
    name: "reset-password-token"
  }, {
    path: "/set-password/:token?",
    component: _7429e40c,
    name: "set-password-token"
  }, {
    path: "/",
    component: _01554f9b,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
